import { ConditionVariable } from "./condition-variable";

// FIXME: Unify with ##ChangeObservable?
export class TemporaryUndefinedContainer<T> {
    private _definedCV = new ConditionVariable();

    constructor(private _value?: T) {}

    public async getValue(): Promise<T> {
        while (this._value === undefined) {
            await this._definedCV.wait();
        }
        return this._value;
    }

    public setValue(v: T): void {
        this._value = v;
        this._definedCV.notifyAll();
    }
}
